import { cancel, delaySound, Waiter } from "common/promises";
import { spritesDurations } from "./sound";
class StepChangedListen {
    constructor(heartBeatSound) {
        this.heartBeatSound = heartBeatSound;
    }
    stepChanged(step) {
        this.heartBeatSound.stepChange(step);
    }
}
export class HeartBeatMachineSound {
    constructor(sound) {
        this.playing = null;
        this.step = 1;
        this.stepChanged = new Waiter();
        this.stepChangedListener = new StepChangedListen(this);
        this.sound = sound;
    }
    play() {
        this.playing = cancel.root(async (canceler) => {
            while (true) {
                canceler.check();
                switch (this.step) {
                    case 1:
                        await this.play1(canceler);
                        break;
                    case 2:
                        await this.play2(canceler);
                        break;
                    case 3:
                        await this.play3(canceler);
                        break;
                    case 4:
                        await this.play4(canceler);
                        break;
                    case 5:
                        await this.play5(canceler);
                        break;
                }
            }
        });
    }
    async play1(canceler) {
        while (true) {
            if (this.stepChanged.triggered) {
                this.stepChanged.reset();
                return;
            }
            this.sound.play("heartBeatMachine", { volume: 0.5 });
            await delaySound(spritesDurations["heartBeatMachine"] * 2);
            canceler.check();
        }
    }
    async play2(canceler) {
        while (true) {
            if (this.stepChanged.triggered) {
                this.stepChanged.reset();
                return;
            }
            this.sound.play("heartBeatMachine", { volume: 0.6 });
            await delaySound(spritesDurations["heartBeatMachine"] * 1.6);
            canceler.check();
        }
    }
    async play3(canceler) {
        while (true) {
            if (this.stepChanged.triggered) {
                this.stepChanged.reset();
                return;
            }
            this.sound.play("heartBeatMachine", { volume: 0.8 });
            await delaySound(spritesDurations["heartBeatMachine"] * 1.2);
            canceler.check();
        }
    }
    async play4(canceler) {
        while (true) {
            if (this.stepChanged.triggered) {
                this.stepChanged.reset();
                return;
            }
            this.sound.play("heartBeatMachine", { volume: 1 });
            await delaySound(spritesDurations["heartBeatMachine"] * 0.8);
            canceler.check();
        }
    }
    async play5(canceler) {
        return await this.play4(canceler);
    }
    dispose() {
        var _a;
        (_a = this.playing) === null || _a === void 0 ? void 0 : _a.canceler.cancel();
    }
    stepChange(target) {
        this.step = target;
        this.stepChanged.trigger();
    }
}
//# sourceMappingURL=heartBeatMachineSound.js.map